import React from 'react';
import {Redirect} from "react-router-dom";
import {useNavigation} from "v4/features/front/navigation/contexts/NavigationContext";

export default function HomePage() {
    const { getRouteByNativeIdentifier } = useNavigation();
    const dashboardRoute = getRouteByNativeIdentifier('main_dashboard');

    if (!dashboardRoute) return null;

    return (
        <Redirect to={dashboardRoute.url}/>
    )
}
